const GenerateDynamicFollowUpURL = async (uuid, token, path) => {
    let url_param_data = {};

    const flp_data = {
        origin : window.location.origin, 
        uri : `/${path}?`,
        params : "tracker=&pixel=&atp_source=&atp_vendor=&atp_sub1=&atp_sub2=&atp_sub6=&atp_sub3=&atp_sub4=&url_id=&lp_id="
    };

    const flp_url_params = new URLSearchParams(flp_data.params);
    const curr_url_params = new URLSearchParams(localStorage.getItem("tracking_url_params") ?? window.location.search);
    
    curr_url_params.forEach((value, key) => {
        Object.assign(url_param_data, {
            [key] : value
        })
    });

    flp_url_params.forEach((value, key) => {
        flp_url_params.set(key, url_param_data[key] ?? value);
    });

    flp_url_params.set('pixel', uuid);
    flp_url_params.set('atp_sub2', token);
    flp_url_params.set('atp_sub6', 'FLP_DUPLICATE');

    const FLP_URL = flp_data.uri + flp_url_params;    
    return FLP_URL;
}

export default GenerateDynamicFollowUpURL